import { z } from "zod"
import { OrganizationTypeEnum } from "../../companies/dtos"

export const CostSourceEnum = {
  Whatsapp: "Whatsapp",
  OpenAI: "OpenAI",
  Anthropic: "Anthropic",
} as const

export type CostSource = keyof typeof CostSourceEnum

export const BackofficeCostsResponseDataSchema = z.object({
  avgDailyCost: z.number().optional(),
  costPerConversation: z.number().optional(),
  costPerMessage: z.number().optional(),
  dailyCosts: z.array(
    z.object({
      date: z
        .date()
        .transform((value) => (value ? value.toISOString() : null))
        .nullable(),
      costs: z.object({
        total: z.number(),
        Whatsapp: z.number().optional(),
        OpenAI: z.number().optional(),
        Anthropic: z.number().optional(),
      }),
    }),
  ),
})

const CostDataSchema = z.object({
  total: z.number().optional(),
  whatsapp: z.number().optional(),
  completions: z.number().optional(),
})

export const BackofficeCompanyCostsItemSchema = z.object({
  avgMonthlyCost: CostDataSchema.optional(),
  currentMonthCost: CostDataSchema.optional(),
  costPerMessage: CostDataSchema.optional(),
})

export const BackofficeCompanyCostsResponseDataSchema = z.array(
  z.object({
    company: z.object({
      id: z.string(),
      name: z.string(),
      logo: z.string().nullable(),
      type: z.enum(OrganizationTypeEnum),
      mrr: z.number().optional(),
      createdAt: z.date().transform((value) => value.toISOString()),
    }),
    costs: BackofficeCompanyCostsItemSchema,
    margin: z.number().optional(),
  }),
)
